import { render, staticRenderFns } from "./BlockListAccordionSharedItemsCustom.vue?vue&type=template&id=92cd86dc&"
import script from "./BlockListAccordionSharedItemsCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListAccordionSharedItemsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports